import type { LineItemType } from "@remi/enums/line-item-type";
import type { PricingType } from "@remi/enums/pricing-type";
import type { LineItemMapKey } from "@remi/types/lineItemPrice";

export function stripRemiIds(remiId: string) {
  return parseInt(remiId.replace(/\D/g, ""));
}

export function makeCompositeId(...ids: (string | number)[]) {
  return ids.join("-");
}

export function makeLineItemCompositeId(lineItem: LineItemType, pricingType: PricingType): LineItemMapKey {
  return `${lineItem}-${pricingType}`;
}

export function createIdFromName(name: string) {
  return name.replace(/\W+/g, " ").trim().replace(/\s+/g, "_").toLowerCase();
}

export function getThumbnailId(file: { id: string }): `${string}-thumb` {
  return `${file.id}-thumb`;
}

export function isThumbnailId(id: string): boolean {
  return id.endsWith("-thumb");
}

export const gutCheckToId = (prefix: string, suffix: string) => `anomaly::${prefix}::${suffix}`;
